import React, {Component} from 'react';
import {Modal, Row, Col} from 'react-bootstrap';
import {SubmitBtn, LogOutBtn} from '../../theme/MorsTheme';
import {RESPONSE} from '../../resources/constant';
import Idle from 'react-user-idle';

export default class LogoutBtn extends Component{    	      
    constructor(props) {
        super(props);       
        this.modalShow = this.modalShow.bind(this); 
        this.modalHide = this.modalHide.bind(this);
        this.state = {
            menus: JSON.parse(localStorage.getItem(RESPONSE)),  
            open: false,
            show: false,                    
        };        
      }


    modalShow(event){       
        event.preventDefault();       
        this.setState({ show: true });         
    }

    modalHide(event) {
        event.preventDefault();      
        this.setState({ show: false,            
        });        
      }

          
    render(){       
        return(  
            <div>
                
            <Row style={{paddingTop: '1px'}} >
                <Col className="col-8">
                <form >
                 <div class="input-group mb-3 input-group-sm">
                    <input type="text" class="form-control" />  
                    <div class="input-group-prepend">
                    <button><img style={{minWidth: '10px', minHeight: '5px'}} height={10} alt="thumbnail" src="media/images/search-icon.png" /> </button>
                        {/* <button class="btn btn-primary">&#x1F50D;</button> */}
                    </div>
                 </div>
                </form>
                </Col>     
                <Col className="col-4"><LogOutBtn onClick={this.modalShow} align="right">Log Out</LogOutBtn></Col>
            </Row>
                       
            

            <Modal  dialogClassName="modal-bdo" show={this.state.show} backdrop={'static'}  onHide={this.modalHide} centered={true} backdropClassName='fade'>                
                    <Modal.Header style={{backgroundColor:'#0B2972', height:'40px', padding:'15px, 0px'}}>                      
                        <Modal.Title style={{fontSize:'14px', color:'white'}}><span>Logout Confirmation</span></Modal.Title>
                    </Modal.Header>
                    <Modal.Body >    
                        
                                <Row align="center">
                                    <Col>
                                    Are you sure you want to logout?                                     
                                    </Col>                                
                                </Row>
                                <Row align="center" style={{paddingTop: '10px'}}>
                                    <Col>
                                        <SubmitBtn onClick={()=> this.props.handleLogout()}>Yes</SubmitBtn>                                                                    
                                        <SubmitBtn onClick={this.modalHide}>No</SubmitBtn>    
                                    </Col>
                                </Row>                        
                    </Modal.Body>                                                               
            </Modal>  
            </div>                  
        )
    }
}




